import { tv } from 'tailwind-variants';

import type { TextAlign, TextColor, TextSize, TextWeight } from './Text.types';

export const text = tv({
	variants: {
		size: {
			small: 'text-xs',
			medium: 'text-base',
			large: 'text-lg',
		} satisfies Record<TextSize, string>,
		weight: {
			normal: 'font-normal',
			medium: 'font-medium',
			semibold: 'font-semibold',
			bold: 'font-bold',
		} satisfies Record<TextWeight, string>,
		color: {
			default: 'text-foreground',
			subdued: 'text-muted-foreground',
			negative: 'text-red-700',
			primary: 'text-indigo-500',
		} satisfies Record<TextColor, string>,
		align: {
			left: 'text-left',
			center: 'text-center',
			right: 'text-right',
		} satisfies Record<TextAlign, string>,
		truncate: {
			// `block` because `overflow` is ignored on inline boxes, `min-w-0` so the box can
			// shrink below its nowrap content width when it is a flex/grid item.
			true: 'block min-w-0 truncate',
		},
	},
	defaultVariants: {
		size: 'medium',
		weight: 'normal',
		color: 'default',
		align: 'left',
	},
});
